import React from 'react';
import { Link } from 'react-router-dom';

// Import SVG icons for digital products
import MobileAppsIcon from '../assets/svg/mobile-app.svg';
import WebAppsIcon from '../assets/svg/web-app.svg';
import BrandStartupsIcon from '../assets/svg/startups.svg';
import BackendSystemsIcon from '../assets/svg/backend.svg';
import UIUXKitsIcon from '../assets/svg/ui-ux.svg';
import AIAutomationIcon from '../assets/svg/ai.svg';
import CoursesIcon from '../assets/svg/courses.svg';
import GraphicDesignIcon from '../assets/svg/graphic-design.svg';

// Keep trending icon
import TrendingIcon from '../assets/svg/images/Trending.png';

export default function Categories() {
    const categories = [
        // Keep Trending category
        { 
            name: 'Trending', 
            image: TrendingIcon, 
            route: '/trending', 
            isTrending: true 
        },
        
        // New Digital Product Categories
        { 
            name: 'Mobile Apps', 
            image: MobileAppsIcon, 
            route: '/category/mobile-apps',
            isDigital: true 
        },
        { 
            name: 'Web Apps', 
            image: WebAppsIcon, 
            route: '/category/web-apps',
            isDigital: true 
        },
        { 
            name: 'Brand Startups', 
            image: BrandStartupsIcon, 
            route: '/category/brand-startups',
            isDigital: true 
        },
        { 
            name: 'Backend Systems', 
            image: BackendSystemsIcon, 
            route: '/category/backend-systems',
            isDigital: true 
        },
        { 
            name: 'UI/UX Kits', 
            image: UIUXKitsIcon, 
            route: '/category/ui-ux-kits',
            isDigital: true 
        },
        { 
            name: 'AI & Automation', 
            image: AIAutomationIcon, 
            route: '/category/ai-automation',
            isDigital: true 
        },
        { 
            name: 'Programming Courses', 
            image: CoursesIcon, 
            route: '/category/programming-courses',
            isDigital: true 
        },
        { 
            name: 'Graphic Designs', 
            image: GraphicDesignIcon, 
            route: '/category/graphic-designs',
            isDigital: true 
        },
    ];

    return (
        <div className="min-h-screen bg-black py-6 px-4">
            <style jsx>{`
                .shelf-container {
                    perspective: 1000px;
                }
                .shelf-item {
                    position: relative;
                    transform-style: preserve-3d;
                    transition: all 0.3s ease;
                }
                .shelf-item::before {
                    content: '';
                    position: absolute;
                    bottom: -6px;
                    left: 0;
                    width: 100%;
                    height: 6px;
                    background: linear-gradient(to bottom, #d1d1d1, #a3a3a3);
                    transform: rotateX(-45deg);
                    transform-origin: top;
                    border-radius: 0 0 3px 3px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                .shelf-item::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0) 50%);
                    border-radius: 6px;
                    pointer-events: none;
                }
                .shelf-item:hover {
                    transform: translateY(-4px) rotateX(5deg);
                }
                .shelf-item-inner {
                    position: relative;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    box-shadow: 0 3px 10px rgba(0,0,0,0.1);
                    border: 1px solid rgba(255,255,255,0.2);
                }
                .trending-shelf {
                    background: linear-gradient(135deg, #fcd34d, #fbbf24);
                    border-left: 3px solid #f59e0b;
                }
                .digital-shelf {
                    background: linear-gradient(135deg, #3b82f6, #2563eb);
                    border-left: 3px solid #1e3a8a;
                }
                .shelf-label {
                    position: relative;
                    padding: 4px 8px;
                    border-radius: 3px;
                    font-weight: 600;
                    text-shadow: 0 1px 1px rgba(0,0,0,0.1);
                    font-size: 0.75rem;
                    line-height: 1rem;
                    margin-top: 8px;
                }
                .trending-label {
                    background-color: rgba(245, 158, 11, 0.2);
                    color: #92400e;
                }
                .digital-label {
                    background-color: rgba(59, 130, 246, 0.2);
                    color: white;
                }
                .shelf-icon {
                    width: 48px;
                    height: 48px;
                    object-fit: contain;
                    filter: brightness(0) invert(1); /* Makes white icons */
                }
                .trending-icon {
                    filter: none; /* Keep trending icon as is */
                }
            `}</style>

            <div className="max-w-6xl mx-auto">
                <h1 className="text-2xl font-bold text-white mb-6 text-center">
                    Browse Categories
                </h1>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 shelf-container">
                    {categories.map((category) => (
                        <Link
                            key={category.name}
                            to={category.route}
                            className="shelf-item h-28"
                        >
                            <div className={`shelf-item-inner h-full p-2 ${
                                category.isTrending ? 'trending-shelf' : 'digital-shelf'
                            }`}>
                                <img
                                    src={category.image}
                                    alt={category.name}
                                    className={`shelf-icon mb-1 ${
                                        category.isTrending ? 'trending-icon' : ''
                                    }`}
                                    onError={(e) => {
                                        console.error(`Failed to load icon: ${category.name}`);
                                        e.target.style.display = 'none';
                                    }}
                                />

                                <span className={`shelf-label text-center ${
                                    category.isTrending ? 'trending-label' : 'digital-label'
                                }`}>
                                    {category.name}
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}